// Module
var code = "<div> <section class=\"heading\"> <div class=\"row no-gutter\"> <ng-include src=\"'/dashboard/nav.html'\"></ng-include> </div> </section> <div class=\"row no-gutter\"> <div class=\"col-md-12 m m-t-lg\"> <ng-include src=\"'/shared/publicProfile.html.erb'\"></ng-include> </div> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '/dashboard/profile.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;